export const routes = {
    home: '/',
    logIn: '/logIn',
    logOut: '/logOut',
    error: '/error',
    register: '/register',
    resetpassword: '/resetpassword',
    resetpasswordmessage: '/resetpasswordmessage',
    updatepassword: '/updatepassword',
    updatepasswordsuccess: '/updatepasswordsuccess',
    signInWithSso: '/signInWithSso',
    signInWithSsoSuccess: '/signInWithSsoSuccess',
    signUpActivate: '/activate',
    challengeUrl: '/api/auth/identity/external/v1/challenge'
};
